import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { INoteListResponse, INoteResponse } from '../models/dashboard.models';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  getNotesList(body: any): Observable<INoteListResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}note/list`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<INoteListResponse>(url, body, httpOptions);
  }

  createNote(body: any): Observable<INoteResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}note/create`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<INoteResponse>(url, body, httpOptions);
  }

  searchNote(body: any): Observable<INoteListResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}note/search`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<INoteListResponse>(url, body, httpOptions);
  }

  deleteNote(noteId: number){
    const token = this.authService.token;
    const url = `${environment.serverUrl}note/delete`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }

    let body = {
      noteId: noteId
    }

    return this.http.post(url, body, httpOptions);
  }

  updateNote(body: any): Observable<INoteResponse>{
    const token = this.authService.token;
    const url = `${environment.serverUrl}note/update`;
    if(token == undefined){
      throw new Error('Token is not present');
    }
    
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<INoteResponse>(url, body, httpOptions);
  }
}
